import './applianceDescription.scss';

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import { IAppliance } from '../../interfaces';
import rightArrowIcon from '@progymedia/sbi-web-englander/src/images/englander-icons/Right-Arrow-Icon.svg';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { AppliancePreviewVisao } from './AppliancePreviewVisao';
import useMobileDetect from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Hooks/useMobileDetect';
import ModalProductPreviewVisao from './ModalProductPreviewVisao';

export default function ApplianceDetails(props: { appliance: IAppliance }) {
    const { appliance } = props;
    const { currentLocale } = usePageLocalization();
    const { t } = useTranslation('layout');
    const isAndroid = useMobileDetect().isAndroid();

    const [showModal, setShowModal] = useState<boolean>(false);

    const visaoId = appliance.attributes?.visao_id?.values?.[0]?.['en_CA'];

    const showInMySpaceButton =
        !appliance?.slug?.['en_CA']?.includes('inserts') && visaoId;

    const navigateToVisaoPage = (visaoId: string) => {
        const lang = currentLocale === 'fr_CA' ? 'fr' : 'en';
        const a: HTMLAnchorElement = document.createElement('a');
        a.target = '_blank';
        a.href = `https://demo.visao.ca/viewer/${visaoId}?lang=${lang}&ar=true`;
        a.click();
    };

    const startAR = () => {
        if (isAndroid) {
            navigateToVisaoPage(visaoId!);
        } else {
            setShowModal(true);
        }
    };

    return (
        <div className='appliance-description-container'>
            <div className='appliance-banner'>Description</div>
            <div className='appliance-description-content'>
                <div className='left'>
                    <div
                        className='description-text'
                        dangerouslySetInnerHTML={{
                            __html: appliance?.description
                                ?.valuesMarkdownRemark?.[currentLocale],
                        }}
                    />

                    {showInMySpaceButton && (
                        <Button
                            className={`visao-btn visao-btn-desktop`}
                            label={t('appliance.see-product-space')}
                            iconRight={rightArrowIcon}
                            onClick={() => startAR()}
                        />
                    )}
                </div>
                {visaoId && (
                    <div className='right'>
                        <AppliancePreviewVisao
                            visaoId={visaoId!}
                            appliance={appliance}
                        />
                    </div>
                )}
                {showInMySpaceButton && (
                    <button
                        className={`visao-btn visao-btn-mobile`}
                        onClick={() => startAR()}
                    >
                        {t('appliance.see-product-space')}
                        <img className='iconRight' src={rightArrowIcon} />
                    </button>
                )}
            </div>
            <ModalProductPreviewVisao
                isOpen={showModal}
                visaoId={visaoId}
                isStartAR={showModal}
                handleModalClose={() => setShowModal(false)}
                product={appliance}
            />
        </div>
    );
}
